import {
  FETCH_USER_MODULE_DETAILS_REQUEST,
  FETCH_USER_MODULE_DETAILS_SUCCESS,
  FETCH_USER_MODULE_DETAILS_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const fetchUserModuleDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_MODULE_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_USER_MODULE_DETAILS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_USER_MODULE_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default fetchUserModuleDetailsReducer;
